import React from 'react';
import universal from 'react-universal-component';
import { LoadingPage } from 'components/core/LoadingPage';

const options = {
	loading: LoadingPage,
	timeout: 60000,
};

const FacilityPageV2 = universal(
	import(
		/* webpackChunkName: "FacilityPageV2" */ '../FacilityPageV2/FacilityPageV2'
	),
	options,
);

export default function FacilityPageWrapper(props) {
	return <FacilityPageV2 {...props} />;
}
